export const actionTypes = {
  UPDATE_NEXT_MATERIAL: 'UPDATE_NEXT_MATERIAL',
  CREATE_ORGANIZER_LINK: 'CREATE_ORGANIZER_LINK',
  UPDATE_COURSE_PROGRESS: 'UPDATE_COURSE_PROGRESS',
};
